import { render, staticRenderFns } from "./SidemenuLayoutBase.vue?vue&type=template&id=0a5e1d90&scoped=true&lang=pug&"
import script from "./SidemenuLayoutBase.vue?vue&type=script&lang=ts&"
export * from "./SidemenuLayoutBase.vue?vue&type=script&lang=ts&"
import style0 from "./SidemenuLayoutBase.vue?vue&type=style&index=0&id=0a5e1d90&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5e1d90",
  null
  
)

export default component.exports